import { useToast } from 'braid-design-system';
import { useState, type Dispatch } from 'react';
import { useDispatch } from 'react-redux';

type DispatchFunction = (
  setStatus: Dispatch<SubmitStatus>,
  ...otherProps: any
) => any;

type Status = 'SUCCESS' | 'FAIL' | 'LOADING';

export interface SubmitStatus {
  status: Status;
  data?: any;
}

type NotifyResult = { show: true; testId: string } | { show: false };

export const useSubmit = (
  submit: DispatchFunction,
  notifyResult: NotifyResult = { show: false },
) => {
  const [submitStatus, setSubmitStatus] = useState<SubmitStatus>();
  const showToast = useToast();
  const dispatch = useDispatch();
  const setStatus = (s: SubmitStatus) => {
    setSubmitStatus(s);
    if (notifyResult.show && s.status !== 'LOADING') {
      showToast({
        tone: s.status === 'SUCCESS' ? 'positive' : 'critical',
        message: s.data?.message ?? s.status,
        data: { testid: notifyResult.testId },
      });
    }
  };
  const dispatchedSubmit = (...props: any) => {
    dispatch(submit(setStatus, ...props));
  };
  return {
    submit: dispatchedSubmit,
    submitStatus,
  };
};
